const subscribe = [
  'Private.Toyota.VehicleInfo.HUSystem.DriversDistraction',
  'Private.Toyota.VehicleInfo.HUSystem.DayNight',
  'Private.Toyota.VehicleInfo.VehicleState.Gear',
  'Signal.OBD.HybridBatteryRemaining',
  'Signal.Drivetrain.Transmission.Speed',
  'Signal.Drivetrain.FuelSystem.Range'
];

export default {
  subscribe,
};
